document.addEventListener('DOMContentLoaded', function () {
  const boxProducts = document.querySelectorAll('.box-product');

  boxProducts.forEach(function (boxProduct) {
    boxProduct.addEventListener('click', function () {
      const text = boxProduct.querySelector('.text-small');
      const icon = boxProduct.querySelector('.icon--icon-arrow-up');

      text.classList.toggle('expanded');
      icon.classList.toggle('icon-rotate');
    });
  });
});
